import { Section, NameBanner, Button } from '@rumblefish/ui/Rumblefish23Theme';
import {
  DescriptionText,
  MainText,
  Point,
  PointsWrapper,
  RowWrapper,
  StyledContentStack,
  StyledInfoStack,
  StyledPointText,
  StyledStack,
  StyledTextStack,
} from './styles';
export const TechStack = ({ ...props }) => {
  return (
    <Section width="normal" borderBottomOn>
      <StyledStack {...props}>
        <NameBanner type="section" text={'TechStack'} color="magenta" />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">
              TechStack For AI Chatbot Development Services with Rumble Fish
            </MainText>
            <StyledInfoStack>
              <PointsWrapper>
                <RowWrapper>
                  <Point />
                  <StyledPointText variant="regular_400">
                    RAG (Retrieval-Augmented Generation)
                  </StyledPointText>
                </RowWrapper>
                <RowWrapper>
                  <Point />
                  <StyledPointText variant="regular_400">
                    LLM (Large Language Model): GPT-4, Llama2, Claude2, PaLM,
                    Gemini, Falcon, Cohere, and others
                  </StyledPointText>
                </RowWrapper>
                <RowWrapper>
                  <Point />
                  <StyledPointText variant="regular_400">
                    Vector databases: Qdrant, Pinecone
                  </StyledPointText>
                </RowWrapper>
                <RowWrapper>
                  <Point />
                  <StyledPointText variant="regular_400">
                    Frameworks: Langchain, Semantic Kernel, Autogen
                  </StyledPointText>
                </RowWrapper>
                <RowWrapper>
                  <Point />
                  <StyledPointText variant="regular_400">
                    Languages: Python, TypeScript
                  </StyledPointText>
                </RowWrapper>
              </PointsWrapper>
              <DescriptionText variant="regular_400">
                Our AI chatbots are channel-agnostic, meaning they seamlessly
                integrate across various communication channels to meet your
                customers wherever they are. Whether your audience prefers
                interaction through your website, mobile app, popular social
                media platforms, or messaging services, our chatbots ensure a
                consistent and unified experience. This channel-agnostic
                approach not only enhances accessibility for your users but also
                streamlines your communication strategy. Whether you wish to
                integrate the chatbot with your Messenger, Slack, WhatsApp, or a
                dedicated mobile app - we’ve got you covered.
              </DescriptionText>
            </StyledInfoStack>
          </StyledTextStack>
        </StyledContentStack>
        <Button link="/contact" variant="link">
          Yes, I want to build a custom AI chatbot
        </Button>
      </StyledStack>
    </Section>
  );
};
